import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, map, pluck } from 'rxjs/operators';
import { Apollo } from 'apollo-angular';
import { ToastService } from 'src/app/core/toast.service';
import { getAllClients, getAllClientsCount, getAllClientsPractice, getAllClientsProf, getAllClientsSupplier, getClientById, getDentalPracticeById, getDentalProfById, getDentalSupplierById, getDirectoryById, getpracticeCount, getProfessionalCount, getSupplierCount, getUserSubPlans, UPDATE_CLIENT_BY_ID, UPDATE_COMMUNITY_STATUS, UPDATE_DENTAL_PRACTICE, UPDATE_DENTAL_PRACTICE_COMMUNITY_STATUS, UPDATE_DENTAL_PROFESSIONAL, UPDATE_DENTAL_PROFESSIONAL_COMMUNITY_STATUS, UPDATE_DENTAL_SUPPLIER, UPDATE_DENTAL_SUPPLIER_COMMUNITY_STATUS, UPDATE_DIRECTORY_COMMUNITY_STATUS , UPDATE_USER_DATA, updateClientStatusData,  updateDentalProfessionalStatus, updateDentalSuppliersStatus, updateDentalPracticeStatus } from '../queries/clients.query';
import { v4 as uuidv4 } from 'uuid';
@Injectable({
  providedIn: 'root'
})
export class ClientsService {

  constructor(private apollo: Apollo, private toast:ToastService) { }

  // getClients(): Observable<any>{

  //   return this.apollo.use("external").subscribe({
  //     query : getAllClients
  //   }).pipe(pluck('data', 'clients'));
  
  // }

  getProfClients(): Observable<any>{

    return this.apollo.use("external").subscribe({
      query : getAllClientsProf
    }).pipe(pluck('data', 'clients'));
  
  }

  getSuppliersClients(){

    return this.apollo.use("external").subscribe({
      query : getAllClientsSupplier
    }).pipe(pluck('data', 'clients'));

  }

  getPracticeClients(){

    return this.apollo.use("external").subscribe({
      query : getAllClientsPractice
    }).pipe(pluck('data', 'clients'));

  }


  getClientById(id: string): Observable<any> {
    console.log(id)
    return this.apollo.use("external").subscribe({
      query: getClientById,
      variables: {id}
    }).pipe(pluck('data', 'clients_by_pk'));
  }

  getPracticeById(id: string): Observable<any> {
    console.log(id)
    return this.apollo.use("external").subscribe({
      query: getDentalPracticeById,
      variables: {id}
    }).pipe(pluck('data', 'dental_practices_by_pk'));
  }

  getProfessionalById(id: string): Observable<any> {
    console.log(id)
    return this.apollo.use("external").subscribe({
      query: getDentalProfById,
      variables: {id}
    }).pipe(pluck('data', 'dental_professionals_by_pk'));
  }

  getSupplierById(id: string): Observable<any> {
    console.log(id)
    return this.apollo.use("external").subscribe({
      query: getDentalSupplierById,
      variables: {id}
    }).pipe(pluck('data', 'dental_suppliers_by_pk'));
  }

    getDirectoryById(id: string): Observable<any> {
    return this.apollo.use('external').watchQuery({
        query: getDirectoryById,
        variables: { id },
        fetchPolicy: 'network-only',
      })
      .valueChanges.pipe(
        pluck('data', 'directories'),
        map((directories: any[]) => directories?.[0] || null)
      );
  }

  getuserSub(id: string): Observable<any> {
    console.log(id)
    return this.apollo.use("external").subscribe({
      query: getUserSubPlans,
      variables: {id}
    }).pipe(pluck('data', 'user_subscriptions'));
  }

  updateClientStarus(id,updateObj){
    console.log(id)
    //const updateObj = {updateObj:statusData}
    console.log(updateObj)
      return  this.apollo.use("external").mutate({
        mutation: updateClientStatusData,
        variables: {id,updateObj}
      }).pipe(pluck('data', 'update_clients_by_pk'));
  
      
  
    }

    // Newly added general update method
updateRelatedTable(type: string, id: string, updateObj: any) {

  let mutation;

  switch (type) {
    case "DENTAL PROFESSIONAL":
      mutation = updateDentalProfessionalStatus;
      break;

    case "DENTAL BUSINESS OWNER":
      mutation = updateDentalSuppliersStatus;
      break;

    case "DENTAL PRACTICE OWNER":
      mutation = updateDentalPracticeStatus;
      break;

    default:
      return null;
  }

  return this.apollo.use("external").mutate({
    mutation,
    variables: { id, updateObj }
  });
}

    updateClient(id: string, updateObj: any) {
  if (!id) {
    throw new Error('Client ID is required for update');
  }

  console.log('Client ID:', id);
  console.log('Update Data:', updateObj);
  
  return this.apollo.use("external").mutate({
    mutation: updateClientStatusData,
    variables: {
      id: id,
      updateObj: updateObj
    }
  }).pipe(
    pluck('data', 'update_clients_by_pk')
  );
}

    practiceCount(): Observable<any> {
      return this.apollo.use("external").subscribe({
        query : getpracticeCount
        //variables: {id}
      }).pipe(pluck('data', 'clients_aggregate'));
    }

    supplierCount(): Observable<any> {
      return this.apollo.use("external").subscribe({
        query : getSupplierCount
        //variables: {id}
      }).pipe(pluck('data', 'clients_aggregate'));
    }

    professionalCount(): Observable<any> {
      return this.apollo.use("external").subscribe({
        query : getProfessionalCount
        //variables: {id}
      }).pipe(pluck('data', 'clients_aggregate'));
    }


     // Add these new methods
  getAllClients(): Observable<any> {
    return this.apollo.use("external").subscribe({
      query: getAllClients
    }).pipe(pluck('data', 'clients'));
  }

  getAllCount(): Observable<any> {
    return this.apollo.use("external").subscribe({
      query: getAllClientsCount
    }).pipe(pluck('data', 'clients_aggregate'));
  }




  updateClientById(id: string, updates: any) {
    // Clean the updates object to remove undefined/null values
    const cleanedUpdates = Object.keys(updates).reduce((acc, key) => {
      if (updates[key] !== undefined && updates[key] !== null) {
        acc[key] = updates[key];
      }
      return acc;
    }, {});

    return this.apollo.use('external').mutate({
      mutation: UPDATE_CLIENT_BY_ID,
      variables: {
        id: id,
        updates: cleanedUpdates
      }
    }).pipe(
    pluck('data', 'update_clients_by_pk')
  
    );
  }



  // Update methods for each entity type
  updateProfessional(id: string, changes: any) {
    return this.apollo.mutate({
      mutation: UPDATE_DENTAL_PROFESSIONAL,
      variables: {
        id,
        changes
      }
    }).pipe(
       pluck('data', 'update_dental_professionals_by_pk')
 
    );
  }

  updateSupplier(id: string, changes: any) {
    return this.apollo.mutate({
      mutation: UPDATE_DENTAL_SUPPLIER,
      variables: {
        id,
        changes
      }
    }).pipe(
       pluck('data', 'update_dental_suppliers_by_pk')
 
    );
  }

  updatePractice(id: string, changes: any) {
    return this.apollo.mutate({
      mutation: UPDATE_DENTAL_PRACTICE,
      variables: {
        id,
        changes
      }
    }).pipe(
           pluck('data', 'update_dental_practices_by_pk')
   
    );
  }

  // Enhanced saveToBackend method
  saveToBackend(fieldName: string, value: any, userData: any) {
    const id = userData.id;
    const type = userData.type;
    const changes = this.prepareChanges(fieldName, value, userData);

    switch(type) {
      case 'PROFESSIONAL':
        return this.updateProfessional(id, changes);
      case 'SUPPLIER':
        return this.updateSupplier(id, changes);
      case 'PRACTICE':
        return this.updatePractice(id, changes);
      default:
        throw new Error(`Unknown user type: ${type}`);
    }
  }

  // Helper method to prepare the changes object
  private prepareChanges(fieldName: string, value: any, userData: any): any {
    // Handle nested properties (like address, bank_details)
    if (fieldName.includes('.')) {
      const parts = fieldName.split('.');
      const parentProp = parts[0];
      const childProp = parts[1];
      
      // Create a deep copy of the existing data
      const changes = { ...userData };
      
      // Initialize nested object if it doesn't exist
      if (!changes[parentProp]) {
        changes[parentProp] = {};
      }
      
      // Update the specific nested property
      changes[parentProp][childProp] = value;
      
      // Return only the changed nested structure
      return { [parentProp]: changes[parentProp] };
    }
    
    // Handle top-level properties
    return { [fieldName]: value };
  }

 updateCommunityStatus(clientId: string, status: string) {
    //  Generate community_id only if status is "YES"
    const communityId = status === 'YES' ? uuidv4() : null;

    return this.apollo.mutate({
      mutation: UPDATE_COMMUNITY_STATUS,
      variables: {
        id: clientId,
        community_status: status,
        community_id: communityId,
      },
    });
  }

  updateDentalSupplierCommunityStatus(supplierId: string, status: string) {
  const communityId = status === 'YES' ? uuidv4() : null;

  return this.apollo.mutate({
    mutation: UPDATE_DENTAL_SUPPLIER_COMMUNITY_STATUS,
    variables: {
      id: supplierId,
      community_status: status,
      community_id: communityId,
    },
  });
}
  updateDentalPracticeCommunityStatus(practiceId: string, status: string) {
  const communityId = status === 'YES' ? uuidv4() : null;

  return this.apollo.mutate({
    mutation: UPDATE_DENTAL_PRACTICE_COMMUNITY_STATUS,
    variables: {
      id: practiceId,
      community_status: status,
      community_id: communityId,
    },
  });
}
  updateDentalProfCommunityStatus(professionalId: string, status: string) {
  const communityId = status === 'YES' ? uuidv4() : null;

  return this.apollo.mutate({
    mutation: UPDATE_DENTAL_PROFESSIONAL_COMMUNITY_STATUS,
    variables: {
      id: professionalId,
      community_status: status,
      community_id: communityId,
    },
  });
}

updateDirectoryCommunityStatus(directoryId: string, status: string) {
  const communityId = status === 'YES' ? uuidv4() : null;

  return this.apollo.mutate({
    mutation: UPDATE_DIRECTORY_COMMUNITY_STATUS,
    variables: {
      id: directoryId,
      community_status: status,
      community_id: communityId,
    },
  })
}

updateUserData(
  table: string,
  inputType: string,
  id: string,
  clientChanges: any,
  userChanges: any
): Promise<any> {
  const mutation = UPDATE_USER_DATA(table, inputType);
  return this.apollo.mutate({
    mutation,
    variables: { id, clientChanges, userChanges }
  }).toPromise();
}




}
